import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StyledLogout } from './Logout.styles';
import { TextButton } from 'lib/components/Button/TextButton/TextButton';
import { AnalyticsLink } from 'app/cross-cutting-concerns/analytics/interfaces/Analytics.types';
import { useAnalyticsLinkActivated } from 'app/cross-cutting-concerns/analytics/hooks/useAnalyticsLinkActivated';
import { AuthenticationActions } from 'app/cross-cutting-concerns/authentication/state/authenticationActions';
import { selectIsSigningOut } from 'app/cross-cutting-concerns/authentication/state/authenticationSelectors';
import logout from 'app/assets/images/logout.svg';

export const Logout = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const analyticsLinkActivated = useAnalyticsLinkActivated();
  const isSigningOut = useSelector(selectIsSigningOut);

  const handleLogout = useCallback((): void => {
    if (isSigningOut) {
      return;
    }

    analyticsLinkActivated({
      linkName: AnalyticsLink.LOGOUT,
    });
    dispatch(AuthenticationActions.signOut());
  }, [analyticsLinkActivated, dispatch, isSigningOut]);

  return (
    <StyledLogout>
      <TextButton
        size="m"
        className="logout__logout-button"
        loading={isSigningOut}
        disabled={isSigningOut}
        aria-busy={isSigningOut}
        onClick={handleLogout}
      >
        <div className="logout__logout-button-title">
          <span className="logout__logout-button-text">
            {isSigningOut ? t('profile.loggingOut') : t('profile.logoutButton')}
          </span>
          {!isSigningOut && <img src={logout} alt="" aria-hidden="true" />}
        </div>
      </TextButton>
    </StyledLogout>
  );
};
